import { InterestRateTypeEnum } from '@/api/apply-product/types';

export const RateTypeNames = {
  [InterestRateTypeEnum.YEAR]: '综合年化',
  [InterestRateTypeEnum.MONTH]: '月',
  [InterestRateTypeEnum.DAY]: '日',
  [InterestRateTypeEnum.NONE]: '', // 默认值
};

// 针对利率展示精度进行控制
export const getShowRateValue = (rateValue: number, decimal = 3): string => (rateValue * 100).toFixed(decimal).replace(/(\.?[0]+)$/g, '');
